import { render, staticRenderFns } from "./EditReminder.vue?vue&type=template&id=706cbf10&"
import script from "./EditReminder.vue?vue&type=script&lang=js&"
export * from "./EditReminder.vue?vue&type=script&lang=js&"
import style0 from "./EditReminder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports